import React from 'react';
import { Checkout, CheckoutError, CheckoutSuccess } from '~/scenes';
import { Stack } from '../stackNavigation';

export const CheckoutNavigation = (
  <>
    <Stack.Screen name="MarisaServicos_Checkout" component={Checkout} />

    <Stack.Group screenOptions={{ headerShown: false }}>
      <Stack.Screen
        name="MarisaServicos_CheckoutSuccess"
        component={CheckoutSuccess}
      />

      <Stack.Screen
        name="MarisaServicos_CheckoutError"
        component={CheckoutError}
      />
    </Stack.Group>
  </>
);
